module.exports = __webpack_public_path__ + "img/logo-index.190e995a.png";